module.exports = function getResource(label, vars = []) {
    let resources = {
        reset: 'Réinitialiser',
        filter: 'le filtre'
    };
    return resources[label];
};
